/* De La Terre — NanoBioTech Page Molecules v2.1 | deferred/cacheable runtime */
(function() {
  'use strict';

  var root = document.getElementById('dlt-nbt-brand-molecules');

  if (!root || root.dataset.dltReady === 'true') return;

  root.dataset.dltReady = 'true';

  var connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  var saveData = !!(connection && connection.saveData);
  var effectiveType =
    connection && connection.effectiveType
      ? String(connection.effectiveType).toLowerCase()
      : '';

  var isVerySlowConnection =
    effectiveType === 'slow-2g' ||
    effectiveType === '2g';

  if (saveData || isVerySlowConnection) {
    root.dataset.dltSkipped = saveData
      ? 'save-data'
      : 'slow-connection';

    return;
  }

  function ensureStylesheet(callback) {
    var href = root.dataset.dltStyleUrl;

    if (!href) {
      callback();
      return;
    }

    var existing = document.querySelector('link[data-dlt-nbt-stylesheet]');

    if (existing) {
      if (existing.dataset.loaded === 'true' || existing.sheet) {
        callback();
      } else {
        existing.addEventListener('load', callback, { once: true });
      }
      return;
    }

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-dlt-nbt-stylesheet', '');
    link.addEventListener('load', function() {
      link.dataset.loaded = 'true';
      callback();
    }, { once: true });
    link.addEventListener('error', function() {
      root.dataset.dltSkipped = 'style-error';
    }, { once: true });
    document.head.appendChild(link);
  }

  var pageType =
    root.getAttribute('data-dlt-page-type') ||
    'site';

  var isProductPage = pageType === 'product';

  var mobileQuery = window.matchMedia
    ? window.matchMedia('(max-width: 749px)')
    : null;

  var motionQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  var assets = [
    'https://cdn.shopify.com/s/files/1/0573/8089/6834/files/Ativo_33molecula.svg?v=1777398560',
    'https://cdn.shopify.com/s/files/1/0573/8089/6834/files/Ativo_31molecula.svg?v=1777398560',
    'https://cdn.shopify.com/s/files/1/0573/8089/6834/files/Ativo_36molecula.svg?v=1777398700'
  ];

  var layouts = {
    homeDesktop: [
      {
        asset: 0,
        className: 'dlt-nbt-brand-molecule--1'
      },
      {
        asset: 1,
        className: 'dlt-nbt-brand-molecule--2'
      },
      {
        asset: 2,
        className: 'dlt-nbt-brand-molecule--3'
      }
    ],
    homeMobile: [
      {
        asset: 0,
        className: 'dlt-nbt-brand-molecule--1'
      }
    ],
    productDesktop: [
      {
        asset: 1,
        className: 'dlt-nbt-brand-molecule--1'
      },
      {
        asset: 2,
        className: 'dlt-nbt-brand-molecule--2'
      }
    ],
    productMobile: [
      {
        asset: 1,
        className: 'dlt-nbt-brand-molecule--1'
      }
    ],
    reduced: [
      {
        asset: 0,
        className: 'dlt-nbt-brand-molecule--1'
      }
    ]
  };

  var currentLayout = '';
  var resizeFrame = 0;
  var uiFrame = 0;
  var discoveryFrame = 0;
  var discoveryTimer = 0;

  var abortController =
    'AbortController' in window
      ? new AbortController()
      : null;

  var eventOptions = abortController
    ? { signal: abortController.signal }
    : false;

  var passiveEventOptions = abortController
    ? {
        passive: true,
        signal: abortController.signal
      }
    : {
        passive: true
      };

  var uiTargets = new Set();
  var uiObserver = null;
  var bodyObserver = null;
  var discoveryObserver = null;
  var geometryObserver = null;

  var legacyMediaCleanup = [];

  function isMobile() {
    return mobileQuery
      ? mobileQuery.matches
      : window.innerWidth < 750;
  }

  function isReducedMotion() {
    return !!(motionQuery && motionQuery.matches);
  }

  function getLayoutKey() {
    if (isReducedMotion()) {
      return 'reduced';
    }

    if (isProductPage) {
      return isMobile()
        ? 'productMobile'
        : 'productDesktop';
    }

    return isMobile()
      ? 'homeMobile'
      : 'homeDesktop';
  }

  function getItems() {
    return layouts[getLayoutKey()] || layouts.reduced;
  }

  function createMolecule(item, index) {
    var molecule = document.createElement('span');
    var image = document.createElement('img');

    molecule.className =
      'dlt-nbt-brand-molecule ' +
      item.className;

    molecule.setAttribute(
      'data-dlt-nbt-brand-molecule',
      String(index)
    );

    image.alt = '';
    image.width = 180;
    image.height = 180;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.draggable = false;

    image.setAttribute('fetchpriority', 'low');
    image.setAttribute('aria-hidden', 'true');

    image.addEventListener(
      'load',
      function() {
        molecule.classList.add('is-loaded');
      },
      { once: true }
    );

    image.addEventListener(
      'error',
      function() {
        molecule.remove();
      },
      { once: true }
    );

    image.src = assets[item.asset];
    molecule.appendChild(image);

    return molecule;
  }

  function updateSafeTop() {
    var documentStyle =
      window.getComputedStyle(document.documentElement);

    var announcementHeight = parseFloat(
      documentStyle.getPropertyValue(
        '--announcement-bar-height'
      )
    ) || 0;

    var header =
      document.querySelector('store-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('.section-header') ||
      document.querySelector('header');

    var headerHeight = 64;

    if (header) {
      headerHeight = Math.max(
        56,
        Math.ceil(
          header.getBoundingClientRect().height
        )
      );
    }

    var safeTop = Math.max(
      68,
      announcementHeight + headerHeight + 8
    );

    root.style.setProperty(
      '--dlt-nbt-safe-top',
      safeTop + 'px'
    );

    root.style.setProperty(
      '--dlt-nbt-safe-top-mobile',
      Math.max(68, safeTop) + 'px'
    );
  }

  function buildMolecules(force) {
    var nextLayout = getLayoutKey();

    if (!force && currentLayout === nextLayout) {
      updateSafeTop();
      return;
    }

    var fragment =
      document.createDocumentFragment();

    getItems().forEach(function(item, index) {
      fragment.appendChild(
        createMolecule(item, index)
      );
    });

    root.classList.remove('is-visible');
    root.replaceChildren(fragment);

    currentLayout = nextLayout;
    updateSafeTop();
    root.hidden = false;

    window.requestAnimationFrame(function() {
      root.classList.add('is-visible');
      scheduleUiStateUpdate();
    });
  }

  function scheduleResizeWork() {
    if (resizeFrame) return;

    resizeFrame = window.requestAnimationFrame(
      function() {
        resizeFrame = 0;
        buildMolecules(false);
      }
    );
  }

  function targetIsOpen(target) {
    if (!target || !target.isConnected) {
      return false;
    }

    if (
      target.matches('dialog') &&
      typeof target.open === 'boolean'
    ) {
      return target.open;
    }

    return (
      target.hasAttribute('open') ||
      target.classList.contains('open') ||
      target.classList.contains('active') ||
      target.classList.contains('is-open') ||
      target.classList.contains('animate') ||
      target.getAttribute('aria-hidden') === 'false'
    );
  }

  function updateUiState() {
    uiFrame = 0;

    var uiOpen =
      document.body.classList.contains(
        'overflow-hidden'
      );

    if (!uiOpen) {
      uiTargets.forEach(function(target) {
        if (!uiOpen && targetIsOpen(target)) {
          uiOpen = true;
        }
      });
    }

    root.classList.toggle(
      'is-ui-open',
      uiOpen
    );
  }

  function scheduleUiStateUpdate() {
    if (uiFrame) return;

    uiFrame = window.requestAnimationFrame(
      updateUiState
    );
  }

  function observeUiTarget(target) {
    if (
      !target ||
      uiTargets.has(target)
    ) {
      return;
    }

    uiTargets.add(target);

    if (uiObserver) {
      uiObserver.observe(target, {
        attributes: true,
        attributeFilter: [
          'open',
          'class',
          'aria-hidden'
        ]
      });
    }
  }

  function discoverUiTargets() {
    discoveryFrame = 0;

    [
      '#Details-menu-drawer-container',
      'cart-drawer',
      '#cart-drawer',
      '#CartDrawer',
      '.cart-drawer',
      '[data-cart-drawer]',
      'dialog',
      '.modal'
    ].forEach(function(selector) {
      document
        .querySelectorAll(selector)
        .forEach(observeUiTarget);
    });

    var menuDrawer =
      document.querySelector('#menu-drawer');

    if (menuDrawer) {
      observeUiTarget(
        menuDrawer.closest('details') ||
        menuDrawer
      );
    }

    scheduleUiStateUpdate();
  }

  function scheduleUiDiscovery() {
    if (discoveryFrame) return;

    discoveryFrame =
      window.requestAnimationFrame(
        discoverUiTargets
      );
  }

  function setupUiObservers() {
    if (!('MutationObserver' in window)) {
      discoverUiTargets();
      return;
    }

    uiObserver = new MutationObserver(
      scheduleUiStateUpdate
    );

    bodyObserver = new MutationObserver(
      scheduleUiStateUpdate
    );

    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    discoverUiTargets();

    discoveryObserver = new MutationObserver(
      function(mutations) {
        var hasAddedNodes = mutations.some(
          function(mutation) {
            return mutation.addedNodes.length > 0;
          }
        );

        if (hasAddedNodes) {
          scheduleUiDiscovery();
        }
      }
    );

    discoveryObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    discoveryTimer = window.setTimeout(
      function() {
        if (discoveryObserver) {
          discoveryObserver.disconnect();
          discoveryObserver = null;
        }
      },
      5000
    );
  }

  function setupGeometryObserver() {
    if (!('ResizeObserver' in window)) {
      window.addEventListener(
        'resize',
        scheduleResizeWork,
        passiveEventOptions
      );

      return;
    }

    geometryObserver =
      new ResizeObserver(scheduleResizeWork);

    [
      document.querySelector('store-header'),
      document.querySelector(
        '.shopify-section--announcement-bar'
      ),
      document.querySelector(
        'height-observer[variable="announcement-bar"]'
      )
    ].forEach(function(target) {
      if (target) {
        geometryObserver.observe(target);
      }
    });

    window.addEventListener(
      'resize',
      scheduleResizeWork,
      passiveEventOptions
    );
  }

  function addMediaListener(mediaQuery, handler) {
    if (!mediaQuery) return;

    if (
      typeof mediaQuery.addEventListener ===
      'function'
    ) {
      mediaQuery.addEventListener(
        'change',
        handler,
        eventOptions
      );

      return;
    }

    if (
      typeof mediaQuery.addListener ===
      'function'
    ) {
      mediaQuery.addListener(handler);

      legacyMediaCleanup.push(function() {
        mediaQuery.removeListener(handler);
      });
    }
  }

  function handleVisibilityChange() {
    root.classList.toggle(
      'is-paused',
      document.visibilityState === 'hidden'
    );
  }

  function cleanup() {
    if (abortController) {
      abortController.abort();
    }

    legacyMediaCleanup.forEach(
      function(removeListener) {
        removeListener();
      }
    );

    legacyMediaCleanup = [];

    if (uiObserver) {
      uiObserver.disconnect();
    }

    if (bodyObserver) {
      bodyObserver.disconnect();
    }

    if (discoveryObserver) {
      discoveryObserver.disconnect();
    }

    if (geometryObserver) {
      geometryObserver.disconnect();
    }

    if (resizeFrame) {
      window.cancelAnimationFrame(
        resizeFrame
      );
    }

    if (uiFrame) {
      window.cancelAnimationFrame(uiFrame);
    }

    if (discoveryFrame) {
      window.cancelAnimationFrame(
        discoveryFrame
      );
    }

    if (discoveryTimer) {
      window.clearTimeout(discoveryTimer);
    }
  }

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(
        callback,
        { timeout: 2400 }
      );

      return;
    }

    window.setTimeout(callback, 900);
  }

  function runAfterLoad(callback) {
    if (document.readyState === 'complete') {
      runWhenIdle(callback);
      return;
    }

    window.addEventListener(
      'load',
      function() {
        runWhenIdle(callback);
      },
      {
        once: true,
        signal: abortController
          ? abortController.signal
          : undefined
      }
    );
  }

  function init() {
    buildMolecules(true);
    setupUiObservers();

    /*
      DLT CWV/CLS Phase 2:
      o safe-top é calculado enquanto o layer ainda está oculto em
      buildMolecules(). Não observar mudanças de altura do header depois
      que as moléculas ficam visíveis: mover o inset de um elemento fixed
      após o paint foi identificado pelo Shopify RUM como alvo de CLS.
      Mudanças de breakpoint continuam reconstruindo o layer de forma
      oculta antes de exibi-lo novamente.
    */

    document.addEventListener(
      'visibilitychange',
      handleVisibilityChange,
      eventOptions
    );

    document.addEventListener(
      'toggle',
      scheduleUiStateUpdate,
      {
        capture: true,
        signal: abortController
          ? abortController.signal
          : undefined
      }
    );

    [
      'cart:open',
      'cart-drawer:open',
      'cart:close',
      'cart-drawer:close',
      'dialog:after-show',
      'dialog:after-hide'
    ].forEach(function(eventName) {
      document.addEventListener(
        eventName,
        scheduleUiStateUpdate,
        eventOptions
      );

      window.addEventListener(
        eventName,
        scheduleUiStateUpdate,
        eventOptions
      );
    });

    addMediaListener(
      mobileQuery,
      scheduleResizeWork
    );

    addMediaListener(
      motionQuery,
      scheduleResizeWork
    );

    window.addEventListener(
      'pagehide',
      cleanup,
      {
        once: true,
        signal: abortController
          ? abortController.signal
          : undefined
      }
    );

    handleVisibilityChange();
    scheduleUiStateUpdate();
  }

  ensureStylesheet(function() {
    runAfterLoad(init);
  });
})();
